import { render, staticRenderFns } from "./BlobSnowflakes.vue?vue&type=template&id=2549fa62&scoped=true"
import script from "./BlobSnowflakes.vue?vue&type=script&lang=js"
export * from "./BlobSnowflakes.vue?vue&type=script&lang=js"
import style0 from "./BlobSnowflakes.vue?vue&type=style&index=0&id=2549fa62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549fa62",
  null
  
)

export default component.exports